"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageLists = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _messages = require("./messages");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getMessageLists = function getMessageLists(client) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(lists) {
      var _Object$keys;

      var limit,
          initialReduction,
          _lists$reduce,
          args,
          queries,
          variables,
          QUERY,
          results,
          response,
          _args = arguments;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              limit = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;

              if (!(!client || !lists)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", Promise.resolve(undefined));

            case 3:
              initialReduction = {
                args: [],
                queries: [],
                variables: {}
              };
              _lists$reduce = lists.reduce(function (acc, cur) {
                acc.args.push("$".concat(cur.id, "Params: FilterParamsInput"));
                acc.queries.push("".concat(cur.id, ": messages(params: $").concat(cur.id, "Params, limit: $limit) { ").concat(_messages.messagesProps, " } "));
                acc.variables["".concat(cur.id, "Params")] = cur.filters;
                return acc;
              }, initialReduction), args = _lists$reduce.args, queries = _lists$reduce.queries, variables = _lists$reduce.variables;
              QUERY = "query GetMessageLists(".concat(args, ", $limit: Int = 10){\n      ").concat(queries.join(""), "\n    }");
              _context.next = 8;
              return client.query(QUERY, _objectSpread(_objectSpread({}, variables), {}, {
                limit: limit
              })).toPromise();

            case 8:
              results = _context.sent;
              response = (_Object$keys = Object.keys(results.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.reduce(function (acc, listName) {
                var _results$data$listNam;

                acc[listName] = {
                  messages: results.data[listName].nodes,
                  startCursor: (_results$data$listNam = results.data[listName].pageInfo) === null || _results$data$listNam === void 0 ? void 0 : _results$data$listNam.startCursor
                };
                return acc;
              }, {});
              return _context.abrupt("return", response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getMessageLists = getMessageLists;